import {IConstants, ISection} from "../../model/B2CInfo";
import './AppPromoItem.css'
import '../../MainScreen.css'
import {IAppPromoItem} from "./IAppPromoItem";
import {getMobileAppPromo} from "../../../helpers/getMobileAppPromo";
import React from "react";

interface IAppPromoItemProps {
    section: ISection
    mobile: boolean
    constants: IConstants
}

export default function AppPromoItem(props: IAppPromoItemProps) {
    if (props.mobile) {
        let promo = props.section.data as IAppPromoItem;
        let appPromo = getMobileAppPromo(props.constants)
        return <div className="App_promo_item_mobile">
            <div id="app_promo"/>
            <div className="App_promo_item_mobile__title">{props.section.title}</div>
            <div className="App_promo_item_mobile__subtitle">{props.section.subtitle}</div>
            <img src={appPromo.icon} className="App_promo_item_mobile__icon" onClick={(e) => window.open(appPromo.link, "_blank")}/>
            <img src={promo.phone_icon} className="App_promo_item_mobile__phone_icon" style={{height: `${(372 * window.innerWidth/375)}px`}}/>
        </div>
    } else {
        let promo = props.section.data as IAppPromoItem;
        return <div className="App_promo_item">
            <div style={{marginTop: "-72px"}} id={props.section.id}/>
            <div className="Section_container" style={{position: "relative"}}>
                <div className="App_promo_item_left_content">
                    <div className="App_promo_item_left_content_title">
                        {props.section.title}
                    </div>
                    <div className="App_promo_item_left_content_subtitle">
                        {props.section.subtitle}
                    </div>
                    <div className="App_promo_item_left_content_images_row">
                        <div className="App_promo_item_left_content_images_column">
                            <button
                                style={{backgroundImage: `url(${props.constants.app_store_icon})`}}
                                className="App_promo_item_left_content_image"
                                onClick={(e) => window.open(props.constants.app_store_link, "_blank")}
                            />
                            <button
                                style={{backgroundImage: `url(${props.constants.google_play_icon})`}}
                                className="App_promo_item_left_content_image"
                                onClick={(e) => window.open(props.constants.google_play_link, "_blank")}
                            />
                        </div>
                        <img src={props.constants.qr_code_icon} className="App_promo_item_left_content_qr_image"/>
                    </div>
                </div>
                <img src={promo.phone_icon} className="App_promo_item_right_image"/>
            </div>
        </div>
    }
}